export function formateDateTime(date: string, startAt: string): string {
  const dateSplit = date.split('T')[0].split('-');
  const dateFormatted = `${dateSplit[2]}/${dateSplit[1]}`;
  const timeSplit = startAt.split(':');
  const timeFormatted = `${timeSplit[0]}h${timeSplit[1]}m`;

  return `${dateFormatted} - ${timeFormatted}`;
}
